import React, {useEffect, useMemo, useState} from 'react';
import {
    Badge,
    Card,
    Empty,
    Modal,
    Space,
    Tabs,
    Tag,
} from 'antd';
import {
    FileSearchOutlined,
} from '@ant-design/icons';

import {EntityLogResponse} from "../../../../models/logger/logger.data";
import {loggerService} from "../../../../services/logger/logger.service";
import "./entity.modal.scss"
import {EntityLogsTab} from "./parts/tabs/logs/entity.tabs.logs";
import {EntityChangeLogsTab} from "./parts/tabs/change-logs/entity.tabs.change-logs";
import {EntityLogDataPanel} from "./parts/data/entity.data";

interface EntityLogModalProps {
    entityName: string;
    entityId: string;
    onClose: () => void;
}

export const EntityLogModal: React.FC<EntityLogModalProps> = ({
                                                                          entityName,
                                                                          entityId,
                                                                          onClose,
                                                                      }) => {

    const [response, setResponse] = useState<EntityLogResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        loggerService.getEntityLog(entityName, entityId).then(response => {
            setResponse(response)
            setLoading(false);
        })
    }, [entityName, entityId]);

    const tabs = useMemo(
        () => [
            {
                key: 'logs',
                label: (
                    <Space size={6}>
                        Logs
                        <Badge count={response?.logs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <EntityLogsTab
                        logs={response?.logs || []}
                    />
                ),
            },
            {
                key: 'changeLogs',
                label: (
                    <Space size={6}>
                        Change Logs (Parent)
                        <Badge count={response?.changeLogs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <EntityChangeLogsTab
                        changeLogs={response?.changeLogs || []}
                    />
                ),
            },
            {
                key: 'childrenChangeLogs',
                label: (
                    <Space size={6}>
                        Change Logs (Children)
                        <Badge count={response?.childrenChangeLogs?.length || 0} size="small" />
                    </Space>
                ),
                children: (
                    <EntityChangeLogsTab
                        changeLogs={response?.childrenChangeLogs || []}
                    />
                ),
            },
        ],
        [response],
    );

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            width="100vw"
            style={{ top: 0, paddingBottom: 0 }}
            styles={{
                body: {
                    padding: 0,
                    height: 'calc(100vh - 56px)',
                    overflow: 'hidden',
                },
            }}
            wrapClassName="invocation-log-modal"
            title={
                <Space size={10}>
                    <FileSearchOutlined />
                    <span>Entity logs</span>
                    <Tag color="blue">{entityName} {entityId}</Tag>
                </Space>
            }
            loading={loading}
        >
            <div className="invocation-log-modal__content">
                {response ? (
                    <>
                        <EntityLogDataPanel entityId={entityId} entityName={entityName} />

                        <Card className="invocation-log-modal__tabs-card" bordered={false}>
                            <Tabs
                                items={tabs}
                                size="large"
                                destroyInactiveTabPane={false}
                            />
                        </Card>
                    </>
                ) : (
                    <Empty
                        className="invocation-log-modal__empty"
                        description="No invocation log data"
                    />
                )}
            </div>
        </Modal>
    );
}